import {useEffect, useState} from "react";

export default function useScroll() {
    const [body, setBody] = useState<HTMLElement>();

    useEffect(() => setBody(document.body), []);

    function scrollTo(ref: HTMLElement, extraOffset?: number) {
        let top = ref.offsetTop;
        if (extraOffset) top = top + extraOffset;
        if (window) {
            window.scrollTo(0, top);
        }
    }

    return {scrollTo};
}
